import store from '../store'

const showMessage = (message, duration, type, id, destroyId) => {
	store.dispatch('showAlert', { message, duration, type, id, destroyId })
}

export const showSuccess = (message, duration, id, destroyId) => {
	showMessage(message, duration || 2000, 'success', id, destroyId)
}

export const showWarning = (message, duration) => {
	showMessage(message, duration || 2000, 'warning')
}

export const showDanger = (message, duration) => {
	showMessage(message, duration || 2000, 'error')
}

export const showAlert = (message, duration, id, destroyId) => {
	showMessage(message, duration || 2000, 'info', id, destroyId)
}

export const showDark = (message, duration) => {
	showMessage(message, duration || 2000, 'dark')
}
